import React from 'react';
import styled from 'styled-components';
import { useTable, useSortBy } from 'react-table';
import { Table as BootstrapTable } from 'react-bootstrap';
import { ArrowUpShort, ArrowDownShort, ArrowsExpand } from 'react-bootstrap-icons';
import { Badge } from '@atoms/Badges';

type ColumnProps = {
    Header: string,
    accessor: string,
    type?: string,
    typeOption?: any,
    Cell?: object,
}

type Props = {
    column: ColumnProps[],
    data: any,
}

const SimpleTable = ( props: Props ) => {
    const columns: any = props.column;
    const data = props.data;

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
      } = useTable({ columns, data }, useSortBy)

    return (
        <SimpleTableWithStyled>
            <BootstrapTable className="text-center table-light" striped bordered {...getTableProps()}>
                <THead className="table-danger">
                    {headerGroups.map(headerGroup => (
                        <TR {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map(column => (
                                <TH {...column.getHeaderProps(column.getSortByToggleProps({ title: undefined }))}>
                                    {column.render("Header")}
                                    &nbsp;
                                    <TableSortWithStyled>
                                      { column.isSorted ? column.isSortedDesc ? <ArrowUpShort /> : <ArrowDownShort /> : <ArrowsExpand /> }
                                    </TableSortWithStyled>
                                </TH>
                            ))}
                        </TR>
                    ))}
                </THead>
                <TBody {...getTableBodyProps()}>
                    { rows.length ?
                        rows.map((row) => {
                            prepareRow(row);
                            return (
                                <TR {...row.getRowProps()}>
                                    {row.cells.map((cell: any) => {

                                        const cellType = cell?.column?.type;
                                        const cellTypeOption = cell?.column?.typeOption;

                                        switch (cellType){
                                            case 'badge':
                                                let badgeClass;
                                                cellTypeOption.forEach( (element: any) => {
                                                    switch (cell.value) {
                                                        case element.status_name:
                                                            badgeClass = element.color_class;
                                                            break;
                                                    }
                                                });
                                                
                                                return (
                                                    <TD {...cell.getCellProps()}>
                                                        <Badge badgeType={ badgeClass } badgeValue={ cell.render('Cell') } />
                                                    </TD>
                                                );
                                            default:
                                                return <TD {...cell.getCellProps()}>{cell.render('Cell')}</TD>
                                        }

                                    })}
                                </TR>
                            );
                        })
                    : <TR><TD colSpan={columns.length}>データがありません</TD></TR> }
                </TBody>
            </BootstrapTable>
        </SimpleTableWithStyled>
    );
}

const SimpleTableWithStyled = styled.div`
    & thead {
        border-bottom-width: 2px;
    }
`;
const THead = styled.thead`
`;
const TBody = styled.tbody`
`;
const TR = styled.tr`
`;
const TH = styled.th`
`;
const TD = styled.td`
`
const TableSortWithStyled = styled.span`
`

export default SimpleTable;